import { useEffect, useState } from "react";

import { listEmbarcacaoFilterOptions } from "./embarcacoes.gateway";
import type { EmbarcacaoFilterColumn, EmbarcacaoFilterOptionsState } from "./embarcacoes.types";

const NO_OPTIONS: EmbarcacaoFilterOptionsState = { options: [], isLoading: true, hasError: false };

/**
 * AC3 — cada coluna filtrável carrega suas opções do seu próprio serviço
 * (`GET /embarcacoes/filtros/{coluna}`), e não da página em tela: o usuário
 * escolhe qualquer valor existente na frota, mesmo fora do resultado atual.
 * As opções são lidas uma vez por coluna, sem depender da busca nem dos demais
 * filtros — os critérios se combinam na consulta da listagem, não nas listas.
 */
export function useEmbarcacaoFilterOptions(
  column: EmbarcacaoFilterColumn,
): EmbarcacaoFilterOptionsState {
  const [state, setState] = useState<EmbarcacaoFilterOptionsState>(NO_OPTIONS);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();

    setState(NO_OPTIONS);

    listEmbarcacaoFilterOptions({ column, signal: controller.signal })
      .then((options) => {
        if (cancelled) return;
        setState({ options, isLoading: false, hasError: false });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ options: [], isLoading: false, hasError: true });
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [column]);

  return state;
}
